import Breadcrumb, { BreadcrumbProps } from '@components/v2/ui/Breadcrumb/Breadcrumb';
import { ReactElement, ReactNode, isValidElement } from 'react';

export const isBreadcrumbElement = (node: ReactNode): node is ReactElement<BreadcrumbProps> =>
  isValidElement(node) && node.type === Breadcrumb;
